import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Card, Badge } from '../ui'
import type { ImpactReport } from '../../types'

interface Props {
  report: ImpactReport
  className?: string
}

/** Per-question baseline against latest, with the direction badge. */
const ImpactQuestionTable: React.FC<Props> = ({ report, className }) => (
  <Card elevated padding="none" className={className}>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border-light bg-background">
            <th className="text-left px-4 py-3 font-semibold text-foreground-muted"><FormattedMessage id="impact.question" /></th>
            <th className="text-center px-4 py-3 font-semibold text-foreground-muted"><FormattedMessage id="impact.baselineAvg" /></th>
            <th className="text-center px-4 py-3 font-semibold text-foreground-muted"><FormattedMessage id="impact.latestAvg" /></th>
            <th className="text-center px-4 py-3 font-semibold text-foreground-muted"><FormattedMessage id="impact.change" /></th>
            <th className="text-center px-4 py-3 font-semibold text-foreground-muted"><FormattedMessage id="impact.direction" /></th>
          </tr>
        </thead>
        <tbody>
          {report.per_question.map((q, i) => (
            <tr key={i} className="border-b border-background-alt hover:bg-background">
              <td className="px-4 py-3 text-foreground max-w-xs">{q.question_text}</td>
              <td className="text-center px-4 py-3 text-foreground-muted">{q.baseline_avg.toFixed(1)}</td>
              <td className="text-center px-4 py-3 font-semibold text-foreground">{q.latest_avg.toFixed(1)}</td>
              <td className="text-center px-4 py-3">
                <span className={`font-bold ${
                  q.delta > 0 ? 'text-success' : q.delta < 0 ? 'text-error' : 'text-foreground-muted'
                }`}>
                  {q.delta > 0 ? '+' : ''}{q.delta.toFixed(1)}
                </span>
              </td>
              <td className="text-center px-4 py-3">
                {q.direction === 'improved' && <Badge variant="success"><FormattedMessage id="impact.improved" /></Badge>}
                {q.direction === 'declined' && <Badge variant="error"><FormattedMessage id="impact.declined" /></Badge>}
                {q.direction === 'unchanged' && <Badge variant="neutral"><FormattedMessage id="impact.unchanged" /></Badge>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Card>
)

export default ImpactQuestionTable
